'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import AppLayout from '@/components/layout/AppLayout';
import { useCountry } from '@/context/CountryContext';
import { useLanguage } from '@/context/LanguageContext';

// Dynamically import the map component to avoid SSR issues with Leaflet
const GeoMapClient = dynamic(() => import('./GeoMapClient'), {
  ssr: false,
  loading: () => (
    <div
      className="w-full rounded-2xl flex items-center justify-center"
      style={{ height: 'calc(100vh - 120px)', minHeight: '600px', backgroundColor: '#0D3B2E' }}
    >
      <div className="flex flex-col items-center gap-3">
        <div
          className="w-10 h-10 rounded-full border-2 border-t-transparent animate-spin"
          style={{ borderColor: 'rgba(201,151,58,0.4)', borderTopColor: '#C9973A' }}
        />
        <p className="text-sm font-medium" style={{ color: 'rgba(255,255,255,0.5)' }}>
          Loading map…
        </p>
      </div>
    </div>
  ),
});

export default function GeoMapPage() {
  const { profile } = useCountry();
  const { t } = useLanguage();

  return (
    <AppLayout
      title={t('page.geoMapTitle')}
      subtitle={`${t('page.geoMapSub')} ${profile?.name}`}
    >
      <div className="max-w-screen-2xl mx-auto">
        <GeoMapClient />
      </div>
    </AppLayout>
  );
}